import {
  DesignerMessage,
  DesignerMessageType,
  ICreateElementFromActionMessage,
  IHighLightHoveredItemMessage,
  IRemoteUserSelectionsMessage,
  IRenderFrameMessage,
  IScrollIntoViewMessage,
  ISetSelectedCollapseItemMessage,
  ISetSelectedStepItemMessage,
  ISetSelectedTabItemMessage
} from "@kuika/kuika-cl-model";

export class DesignerMessageSender {
  get activeDesignIFrame(): HTMLIFrameElement {
    return document.getElementById("kuika_iframeAgent_canvas") as HTMLIFrameElement;
  }

  send(messageType: DesignerMessageType, message: DesignerMessage) {
    const messageId: string = (Math.floor(Math.random() * 10000) + 1).toString();
    // console.log(">>>>>> Sent Message From Designer To (" + DesignerMessageType[messageType].toString()+", Message ID:"  + messageId + ", " + new Date().getSeconds() + "-" + new Date().getMilliseconds() + " )");
    // console.log(message);
    // console.log(">>>>>>");
    const event = {
      designerMessage: { messageType, message, messageId }
    };
    if (this.activeDesignIFrame != undefined) {
      this.activeDesignIFrame.contentWindow?.postMessage(event, "*");
    }
    /// ///SEND
  }

  highlightHoveredItem = (message: IHighLightHoveredItemMessage) => {
    this.send(DesignerMessageType.highLightHoveredItemMessage, message);
  };

  scrollIntoView = (message: IScrollIntoViewMessage): void => {
    this.send(DesignerMessageType.scrollIntoViewMessage, message);
  };

  renderFrame = (message: IRenderFrameMessage) => {
    this.send(DesignerMessageType.renderFrameMessage, message);
  };

  injectDiToTargetDi = (message: ICreateElementFromActionMessage) => {
    this.send(DesignerMessageType.createElementFromActionMessage, message);
  };

  replaceDi = (message: ICreateElementFromActionMessage) => {
    this.send(DesignerMessageType.replaceElementFromActionMessage, message);
  };

  setSelectedTabItem = (message: ISetSelectedTabItemMessage) => {
    this.send(DesignerMessageType.setSelectedTabItemMessage, message);
  };

  setSelectedStepItem = (message: ISetSelectedStepItemMessage) => {
    this.send(DesignerMessageType.setSelectedStepItemMessage, message);
  };

  setSelectedCollapseItem = (message: ISetSelectedCollapseItemMessage) => {
    this.send(DesignerMessageType.setSelectedCollapseItemMessage, message);
  };

  sendRemoteUserSelections = (message: IRemoteUserSelectionsMessage) => {
    this.send(DesignerMessageType.remoteUserSelectionsMessage, message);
  };
}
